import { CoreSelectionsName } from './name';
import { createAddSyncSlice } from '@sonar-software/xuder';
import { defaultSelectionState } from './state';

import { CoreSelectionNamespace, CoreSelections } from '../../@types';

export type AddCoreSelectionActionData = {
	namespace?: string,
	selections: CoreSelectionNamespace
};

export const addCoreSelectionsSyncSlice = createAddSyncSlice<
	typeof CoreSelectionsName,
	CoreSelections,
	AddCoreSelectionActionData
>({
	name: CoreSelectionsName,
	state: defaultSelectionState,
	transform: (action, state = {}) => {
		const namespace = action?.namespace ?? 'global';
		const selections = action?.selections ?? {};

		if (state[ namespace ]) {
			Object.assign(state[ namespace ], selections);
		} else {
			state[ namespace ] = selections;
		}

		return state;
	}
});
